var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failure-bid"},[_c('h3',{staticClass:"title"},[_vm._v("流标情况：")]),_c('div',{staticClass:"content"},[_c('pre',{staticStyle:{"white-space":"break-spaces"}},[_vm._v("      "+_vm._s(_vm.form.flowBidReason)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }